import {
	ApplicationConfig,
	inject,
	provideAppInitializer,
	provideBrowserGlobalErrorListeners,
	provideZoneChangeDetection
} from '@angular/core';
import {provideRouter, withComponentInputBinding} from '@angular/router';

import {routes} from './app.routes';
import {providePrimeNG} from 'primeng/config';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import Aura from '@primeng/themes/aura';
import {definePreset} from '@primeng/themes';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {DialogService} from 'primeng/dynamicdialog';
import {authInterceptor} from './core/auth/auth.interceptor';
import {AuthInitializerService} from './core/auth/services/auth-initializer.service';
import {ConfirmationService, MessageService} from 'primeng/api';

const LSTicketingPreset = definePreset(Aura, {
	semantic: {
		primary: {
			50: '#eef7ff',
			100: '#d8ecff',
			200: '#b8dcff',
			300: '#84c2ff',
			400: '#4aa2ff',
			500: '#168cff',
			600: '#2568ff',
			700: '#4c46f5',
			800: '#6234d6',
			900: '#552fb0',
			950: '#311663'
		}
	}
});

export const appConfig: ApplicationConfig = {
	providers: [
		ConfirmationService,
		MessageService,
		provideHttpClient(
			withInterceptors([authInterceptor])
		),
		provideAppInitializer(() => {
			const init = inject(AuthInitializerService);
			init.init();
		}),
		provideBrowserGlobalErrorListeners(),
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideRouter(routes, withComponentInputBinding()),
		DialogService,
		provideAnimationsAsync(),
		providePrimeNG({
			theme: {
				preset: LSTicketingPreset,
				options: {
					darkModeSelector: '.dark-mode-toggle'
				}
			}
		})
	]
};
